import axios from 'axios'
import {AuthModel, UserModel} from './_models'

export let API_URL = process.env.REACT_APP_API_URL

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/api/me`
export const LOGIN_URL = `${API_URL}/api/signin`
export const LOGOUT_URL = `${API_URL}/api/signout`
export const REGISTER_URL = `${API_URL}/register`
export const REQUEST_PASSWORD_URL = `${API_URL}/forgot_password`
export const REQUEST_DEMO_URL = `${API_URL}/api/open/request-demo`

// Server should return AuthModel
export function login(username: string, password: string) {
  return axios.post<AuthModel>(LOGIN_URL, {
    username,
    password,
  })
}

// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  return axios.post(REGISTER_URL, {
    email,
    fullName: firstname,
    last_name: lastname,
    password,
    password_confirmation,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {
    email,
  })
}

export function getUserByToken(token: string) {
  return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
    accessToken: token,
  })
}

export function doServerSidelogout() {
  return axios.post<UserModel>(LOGOUT_URL, {})
}

export function requestDemo(name: string, address: string, phone: string) {
  return axios.post(REQUEST_DEMO_URL, {
    name,
    address,
    phone,
  })
}
